import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { api } from "@/lib/api";

let cache = { at: 0, data: null, p: null };
const fetchMarks = () => {
  if (cache.data && Date.now() - cache.at < 55000) return Promise.resolve(cache.data);
  if (!cache.p) cache.p = api.get("/today/flow-marks").then((r) => { cache = { at: Date.now(), data: r.data, p: null }; return r.data; }).catch(() => { cache.p = null; return cache.data; });
  return cache.p;
};

// Live map symbol -> {open_x, bm_x}; shared by all panels, refreshed every minute
export const useFlow = () => {
  const [d, setD] = useState(cache.data);
  useEffect(() => {
    let live = true;
    const load = () => fetchMarks().then((x) => live && x && setD(x));
    load();
    const id = setInterval(load, 60000);
    return () => { live = false; clearInterval(id); };
  }, []);
  const marks = d?.marks || {};
  const min = d?.min || 3;
  const pass = (sym) => { const m = marks[sym]; return !!m && ((m.open_x || 0) >= min || (m.bm_x || 0) >= min); };
  return { ready: !!d, marks, min, pass, filter: (rows = []) => (d ? rows.filter((r) => pass(r.symbol)) : rows) };
};

export const FlowTags = ({ m, min = 3, testid }) => {
  if (!m) return null;
  const open = (m.open_x || 0) >= min, big = (m.bm_x || 0) >= min;
  return (
    <>
      {open && <span className="ml-1 text-[9px] px-1 font-bold rounded-sm bg-amber-500 text-white" title={`Opening candle volume ${m.open_x}× its usual`} data-testid={`${testid}-flow-open`}>OPEN {m.open_x}×</span>}
      {big && <span className="ml-1 text-[9px] px-1 font-bold rounded-sm bg-blue-600 text-white" title={`Strongest 5m candle today ${m.bm_x}× usual for that time${m.bm_at ? ` (${m.bm_at})` : ""}`} data-testid={`${testid}-flow-big`}>BIG MONEY {m.bm_x}×</span>}
    </>
  );
};

export const InTime = ({ t, testid }) => (t ? (
  <span className="inline-flex items-center gap-0.5 text-[9px] font-mono font-bold px-1 py-px rounded-sm bg-sky-100 text-sky-800 border border-sky-300 whitespace-nowrap" title="Time the stock entered this scanner" data-testid={testid}>
    <Clock className="h-2.5 w-2.5" />IN {t}
  </span>
) : null);

export const FlowNote = () => <p className="text-[9px] font-mono text-slate-400 mb-1">showing only stocks with opening volume or Big Money ≥ 3×</p>;
